<template>
  <div></div>
</template>

<script>
export default {
  name: "Analytics",
  data() {
    return {}
  },
  mounted() {
    window.open(
      "https://analytics.google.com/analytics/web/?authuser=1#/p318981992/reports/reportinghub/edit?params=_u..nav%3Dmaui%26_r.._cids%3D0.3,1.2,2.54,4.120,6.119,7.51,8.4,9.1,10.55,11.53,12.50,13.45,14.52,:p6.78,:p7.12,copa-comparison-builder.,copa-filter-builder.,copa-dimensions-panel.,copa-metrics-panel.,copa-visualizations-panel.,ga-conversion-path-length-panel.%26_r.:p6..viewLink.params.params.ri%3Duser-technology-detail%26_r.:p6..viewLink.params.params.ruid%3Duser-technology-detail,user,technology%26_r.:p7..viewLink.params.params.ri%3Duser-technology-detail%26_r.:p7..viewLink.params.params.ruid%3Duser-technology-detail,user,technology&collectionId=user`"
    )
    this.$router.replace("/admin")
  }
}
</script>
